import { io } from "socket.io-client";

const initiateSocket = (userId) => {
  const socket = io(process.env.REACT_APP_BASE_URL, {
    query: { i: userId },
  });

  return socket;
};

export default initiateSocket;
